import { render, staticRenderFns } from "./ReleaseOrderPeriodsSelect.vue?vue&type=template&id=54cc133a"
import script from "./ReleaseOrderPeriodsSelect.vue?vue&type=script&lang=js"
export * from "./ReleaseOrderPeriodsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports